module.exports = __webpack_public_path__ + "static/media/tip5.7fc4d3be.svg";